/*
 * Build flag for the "complete your profile" landing (/complete-profile?t=…;
 * design MY-DESIGN-BRAND-SIGNUP-AND-COMPLETE-PROFILE-1020, PR-C). Same shape
 * as brandSignupEnabled / newslettersEnabled:
 *
 *   VITE_PROFILE_LINKS_ENABLED === 'true' → the authed /complete-profile route
 *     exists (and a signed-out visitor's token is stashed across sign-in).
 *     Absent or anything else = OFF: no route (the catch-all takes the path)
 *     and no request.
 *
 * my-api gates the API separately (MY_PROFILE_LINKS_ENABLED; 404 while off).
 * The env is injectable so tests can pin both sides.
 */
export function profileLinksEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_PROFILE_LINKS_ENABLED === 'true'
}
